import styles from './ProfileDataField.module.css';

const ToggleSwitch = ({ checked, onChange }) => (
  <label className={styles.switch}>
    <input type="checkbox" checked={checked} onChange={onChange} />
    <span className={styles.slider}></span>
  </label>
);

const ProfileDataField = ({
  label,
  description,
  passportValue,
  profileValue,
  fieldName,
  type,
  onChange,
  options = [],
}) => {
  if (type === 'toggle') {
    return (
      <div className={`${styles.fieldContainer} ${styles.toggleContainer}`}>
        <div className={styles.labelGroup}>
          <label>{label}</label>
          <p>{description}</p>
        </div>
        <ToggleSwitch
          checked={profileValue}
          onChange={(e) => onChange(fieldName, e.target.checked)}
        />
      </div>
    );
  }

  if (type === 'multiselect') {
    const handleCheckboxChange = (value) => {
      const currentValues = profileValue || [];
      const newValues = currentValues.includes(value)
        ? currentValues.filter((item) => item !== value)
        : [...currentValues, value];
      onChange(fieldName, newValues);
    };

    const passportDisplayValue =
      Array.isArray(passportValue) && passportValue.length > 0
        ? passportValue.join(', ').replace(/_/g, ' ')
        : 'Not set';

    return (
      <div className={styles.fieldContainer}>
        <div className={styles.labelGroup}>
          <label>{label}</label>
          <p className={styles.passportValue}>
            <strong>Passport Default:</strong>{' '}
            <em style={{ textTransform: 'capitalize' }}>
              {passportDisplayValue}
            </em>
          </p>
        </div>
        <div className={styles.checkboxGrid}>
          {options.map((opt) => (
            <label key={opt.value} className={styles.checkboxLabel}>
              <input
                type="checkbox"
                className={styles.checkboxInput}
                checked={(profileValue || []).includes(opt.value)}
                onChange={() => handleCheckboxChange(opt.value)}
              />
              <span className={styles.checkboxControl}></span>
              {opt.label}
            </label>
          ))}
        </div>
      </div>
    );
  }

  const isOverridden =
    profileValue !== undefined && profileValue !== null && profileValue !== '';

  return (
    <div className={styles.fieldContainer}>
      <div className={styles.labelGroup}>
        <label htmlFor={fieldName}>{label}</label>
        <p className={styles.passportValue}>
          <strong>Passport Default:</strong> {passportValue || <em>Not set</em>}
        </p>
      </div>
      <div className={styles.inputGroup}>
        <textarea
          id={fieldName}
          name={fieldName}
          rows="3"
          value={profileValue || ''}
          placeholder={`Override with a new ${label.toLowerCase()}...`}
          onChange={(e) => onChange(fieldName, e.target.value)}
        />
        {isOverridden && (
          <button
            type="button"
            onClick={() => onChange(fieldName, '')}
            className={styles.resetButton}
          >
            Reset to Default
          </button>
        )}
      </div>
    </div>
  );
};

export default ProfileDataField;
